import React, { useContext, useEffect, useMemo, useState } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import ProductConditions from '../product-conditions';
import { LegacyVariants } from '../product-variants/legacy-variants';
import { Variants } from '../product-variants';
import {
  ProductConditionSummary,
  VariantGroup,
  VariantValues,
} from 'src/types';
import { FiltersWrapper } from './styles';
import { useProductSizeVariants } from 'src/hooks/experiments';

export const ProductFilters: React.FC<IProductFilters> = props => {
  const { categoryId, conditions, variantGroups, variants } = props;
  const { market } = useContext(AppContext);

  // Size variants is hidden behind exxperiment
  const [
    sizeVariantsExperimentEnabled,
    setSizeVariantsExperimentEnabled,
  ] = useState(false);
  const experiment = useProductSizeVariants();
  useEffect(() => {
    setSizeVariantsExperimentEnabled(experiment);
  }, [experiment]);

  // ProductConditions should be visible if product has used offers.
  // ProductConditions should then continue to be visible, even if a selected variant has no conditions.
  // This is why it is wrapped in useMemo, to prevent the ProductConditions from being displayed and hidden back and forth in the UI when selecting variants.
  const showConditions = useMemo(
    () =>
      Boolean(conditions?.filter(c => c.name === 'used' && c.count > 0).length),
    [conditions]
  );

  const hasLegacyVariants =
    variantGroups &&
    variantGroups.length > 0 &&
    market.productVariants?.legacySupportedCategories?.find(
      c => c === categoryId
    );

  const hasVariants = variants && sizeVariantsExperimentEnabled;

  return showConditions || hasLegacyVariants || hasVariants ? (
    <FiltersWrapper>
      {showConditions && <ProductConditions conditions={conditions} />}
      {hasLegacyVariants && <LegacyVariants variants={variantGroups!} />}
      {hasVariants && <Variants variants={variants!} />}
    </FiltersWrapper>
  ) : null;
};

interface IProductFilters {
  categoryId?: string;
  conditions: ProductConditionSummary[];
  variantGroups?: VariantGroup[] | null; // Old variants from legacy
  variants?: VariantValues | null;
}
